import { render, staticRenderFns } from "./tablaDescuentos.vue?vue&type=template&id=f0de718a&scoped=true&"
import script from "./tablaDescuentos.vue?vue&type=script&lang=js&"
export * from "./tablaDescuentos.vue?vue&type=script&lang=js&"
import style0 from "./tablaDescuentos.vue?vue&type=style&index=0&id=f0de718a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0de718a",
  null
  
)

export default component.exports